import React, {useState, useRef} from "react"
import Stars from "./input/stars"
import RadioCustom from "./input/radio-custom"
import Radio from "./input/radio"
import Mobile from "./input/mobile"
import GooglePlaceAutocomplete from "./GooglePlaceAutocomplete"
import SelectCustom from "./input/select-custom"
import DateField from "./input/datefield"
import CheckboxGroup from "./input/checkboxgroup"
import "./JsonInput.scss"
import Default from "./input/default"

export default function JsonInput({json, validation, dependencies, onFieldChange})
{           
    const validate = validation[0] ? validation[0].validate : false
    const [googlePlace, setGooglePlace] = useState('')  

    const Dependencies = (name, value, object) =>
    {
        if(!dependencies) return        
        
        dependencies.map(dependencie =>
        {
            if(dependencie.depend_on === name)
            {
                const target = document.querySelector('.json-input.field_'+dependencie.field)
                const input = document.querySelector('.input_'+dependencie.field)

                if(dependencie.show_when_value_in)
                {
                    for (let value_in of dependencie.show_when_value_in)
                    {
                        if(value_in.toString() === value.toString())
                        {
                            target.classList.add('show')                            
                            target.classList.remove('hide')

                            if(input)
                            {
                                input.classList.add('show')
                                input.classList.remove('hide')
                            }
                            
                            break
                        }

                        target.classList.add('hide')
                        target.classList.remove('show')    
                        
                        if(input)
                        {
                            input.classList.add('hide')
                            input.classList.remove('show')
                        }
                    }
                }

                if(dependencie.hide_when_value_in)
                {
                    for (let value_in of dependencie.hide_when_value_in)
                    {
                        if(value_in.toString() === value.toString())
                        {
                            target.classList.add('hide')
                            target.classList.remove('show')

                            if(input)
                            {
                                input.classList.add('hide')
                                input.classList.remove('show')
                            }
                            break
                        }

                        target.classList.add('show')
                        target.classList.remove('hide')      
                        
                        if(input)
                        {
                            input.classList.add('show')
                            input.classList.remove('hide') 
                        }
                    }
                }
            }
        })
    }    

    const onChange = (key, value) =>
    {      
        if(onFieldChange) onFieldChange(key, value)
    }

    const create = ()=>
    {
        const type = json.type || false

        if(!type) return        

        switch(type)
        {
            case 'stars': return(<Stars json={json} onFieldChange={onFieldChange} />)                
            case 'mobile': return(<Mobile json={json} onFieldChange={onFieldChange} />)
            case 'select':
                return(
                    <div className={"json-input select field_"+json.key}>
                        {json.label && <label for={json.key} dangerouslySetInnerHTML={{__html: json.label}} /> }
                        <select name={json.key}>
                        {
                            json.options.map(option =>
                            {                                        
                                return(
                                    <option className="option" value={option[0]}>{option[1]}</option>
                                )
                            })
                        }
                        </select>
                    </div>
                )

            case 'select-custom': return(<SelectCustom json={json} dependencies={Dependencies} onFieldChange={onChange} />)                                    
            case 'checkbox': return(<CheckboxGroup json={json} dependencies={Dependencies} onFieldChange={onChange} />)
            case 'radio': return(<Radio json={json} dependencies={Dependencies} onFieldChange={onChange} />)

            case 'radio-custom':
                return(
                    <div className={"json-input radio-custom field_"+json.key}>
                        {json.label && <label for={json.key} dangerouslySetInnerHTML={{__html: json.label}} />}
                        <div className="stylized-radio-group">                              
                        {                                        
                            json.options.map((option, index) =>
                            {                                        
                                let checked = false                                
                                if(index === 0) checked = true                                
                                return<RadioCustom name={json.key} value={option[0]} label={option[1]} checked={checked} />
                            })
                        }
                        </div> 
                    </div>  
                )
            
            case 'textarea':
                return(
                    <div className={"json-input textarea field_"+json.key}>
                        {json.label && <label for={json.key} dangerouslySetInnerHTML={{__html: json.label}} />}
                        <textarea className={"input_"+json.key} name={json.key} placeholder={json.placeholder || null} rows="10" />
                    </div>    
                )

            case 'google-address':
            
                return(
                    <div className={"json-input text google-address field_"+json.key}>
                        {json.label && <label for={json.key} dangerouslySetInnerHTML={{__html: json.label}} />}
                        <input className={"input_"+json.key} type="hidden" name={json.key} value={googlePlace} />
                        <GooglePlaceAutocomplete                                                                                                        
                            placeholder = {json.placeholder || null}
                            apiKey = {"AIzaSyBT4CSSRrQFlPxv0Pevnu9B1T2HK75_H6g"}
                            resetError = {()=>{}}
                            onResetField = {()=>{setGooglePlace('')}}
                            onChange = {(place)=>{setGooglePlace(JSON.stringify(place))}} /> 
                    </div>    
                )

            case 'hidden':
                return(
                    <div className={"json-input hidden field_"+json.key}>
                        <input className={"input_"+json.key} type="hidden" name={json.key} />
                    </div>
                )

            case 'date': return(<DateField json={json} dependencies={Dependencies} onFieldChange={onChange} />)
            default: return(<Default json={json} dependencies={Dependencies} onFieldChange={onChange} />)                
        }               
    }
    
    return (<>{create()}</>) 
}